
















import {Component, Prop, Mixins} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

@Component
export default class StatusImg extends Mixins(Assets) {
  @Prop({default: '', type: String}) status: string

  get imgPath(): string {
    switch(this.status) {
      case 'empty':
      case 'failed':
      case 'success':
        return `status/${this.status}.svg`

      // TODO: modify status img에 해당하지 않는 이미지이므로 옮겨야 함
      case 'kakao':
        return 'logo-kakao.svg'
      case 'search':
        return `status/${this.status}.svg`
      case 'warning':
        return 'status/warning.png'
      default:
        return ''
    }
  }
}
